import { EventRouter } from "../events"

export const screenOrientationChanged = new EventRouter<void>("screenOrientationChanged")
